<template>
  <!-- el-dialog(title="调整排序号", width="60%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()") -->
  <el-dialog title="调整排序号"
             :visible.sync="visible"
             width="60%"
             :append-to-body="true"
             :modal-append-to-body="false"
             @close="closeForm()"
             class="tablechose">
    <div style="margin-bottom:30px;font-size:12px;color:#858585">
      调整方式：可拖动一行数据至任意位置，即可实现排序号调整，签位号对应发生变化
    </div>

    <div>
      <el-table ref="dragTable"
                :data="list"
                border
                fit
                highlight-current-row
                row-key="id"
                style="width: 100%">
        <el-table-column type="index"
                         label="排序号"
                         align="center"></el-table-column>
        <el-table-column prop="name"
                         label="俱乐部"
                         align="center"></el-table-column>
        <el-table-column prop="yearScore"
                         label="俱乐部积分"
                         align="center">
                         </el-table-column>
        <el-table-column prop="chairman"
                         label="会长"
                         align="center"></el-table-column>
        <el-table-column prop="mobile"
                         label="会长账号"
                         align="center"></el-table-column>
        <el-table-column prop="lastScore"
                         label="上次比赛成绩"
                         align="center"></el-table-column>
        <el-table-column prop="createTime"
                         label="报名时间"
                         align="center"></el-table-column>
        <!-- <el-table-column prop="memberType"
                         label="会员类型"
                         align="center"></el-table-column> -->
        <!-- <el-table-column prop="refundScale" label="退款比例" align="center"></el-table-column> -->
      </el-table>
    </div>
    <el-button @click="comfirmRefundRee"
                :disabled="comfirmRefundReeBtn"
               type="primary"
               class="Submit">提交修改</el-button>
    <!-- el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定 -->
  </el-dialog>
</template>
<style>
.tablechose {
  position: relative;
}
.Submit {
  position: absolute;
  right: 50px;
  top: 10px;
}
</style>

<script>
import Sortable from 'sortablejs'
export default {
  //   name: "AdjustGameSys",
  data () {
    return {
      visible: false,
      enrollDataOne: [],
      list: [],
      sortable: null,
      enrollData: [],
      enrollDataTwo: [],
      changeList: [],
      comfirmRefundReeBtn: false
    }
  },
  mounted () { },
  methods: {
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    comfirmRefundRee () {
      const h = this.$createElement
          console.log(h)
      this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('p', '确认提交修改？'),
            h('p', '若已有成绩录入，系统将清空所有成绩及积分，重新生成对阵表！请谨慎操作，数据不可恢复。')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeList = []
          this.list.forEach((item, index) => {
              let come = {
                sortNum: index + 1,
                sortId: item.sortId
              }
              this.changeList.push(come)
            })
          console.log(this.list)
          console.log(this.changeList)
          this.$showLoading()
          this.comfirmRefundReeBtn = true
          this.$http({
            url: this.$http.adornUrl(`/ctCompetition/changeCompSort`),
            method: 'post',
            data: this.changeList
          }).then((data) => {
            if (data && data.code === 0) {
              // alert(1)
              this.$showLoading('close')
              this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      // this.$emit('SortFormatrList')
                      this.$emit('refreshSortFormatrList')
                      this.visible = false
                    }
                  })

              // this.visible = false
            } else {
              this.comfirmRefundReeBtn = false
              this.$showLoading('close')
            }
          }).catch(() => {
            this.comfirmRefundReeBtn = false
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改'
          })
        })
     },
    enrollOneChange () { },
    init (val, id, type) {
      // this.$http({
      //   url: this.$http.adornUrl(`/ctCompetition/queryEnroolSortListByCtId/` + id),
      //   method: 'get'
      // }).then((data) => {

      // })
      this.comfirmRefundReeBtn = false
      this.list = []
      console.log(id, type)
      this.visible = true
      // this.enrollDataOne = val
      let params = { ctId: id }
      if (type == 1) {
        //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
        params.orderForm = 0
      } else if (type == 2) {
        //双打默认按级别和-积分和排序
        params.orderForm = 1
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/getClubEnrollListByCtId`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('参赛人员列表：', data)
          this.enrollData = data.list
          this.enrollDataOne = []
          this.enrollDataTwo = []
          for (let i of this.enrollData) {
            if (i.refundScale === null && i.refundFee !== null) {
              i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
            }
            if (i.refundFee === null && i.refundScale !== null) {
              i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
            }

            if (i.bench === 0) {
              //主力
              this.enrollDataOne.push(i)
            }
            if (i.bench === 1) {
              //替补
              this.enrollDataTwo.push(i)
            }
            console.log(this.enrollDataOne)
            console.log(this.enrollDataTwo)
            this.datalist()
          }
        }
      })
      // this.datalist()
    },
    datalist () {
      const arr = this.enrollDataOne
      for (var i = 0; i < arr.length; i++) {
        arr[i].gender = arr[i].gender === 1 ? '女' : '男'
        arr[i].yearScore = arr[i].yearScore ? arr[i].yearScore : 0
        if (arr[i].memberType == 1) {
          arr[i].memberType = '注册会员'
        } else if (arr[i].memberType == 2) {
          arr[i].memberType = '初始会员'
        } else if (arr[i].memberType == 3) {
          arr[i].memberType = '荣誉会员'
        }
        if (arr[i].payStatus == 0) {
          arr[i].payStatus = '未缴费'
        } else if (arr[i].payStatus == 1) {
          arr[i].payStatus = '支付中'
        } else if (arr[i].payStatus == 2) {
          arr[i].payStatus = '已缴费'
        } else if (arr[i].payStatus == 3) {
          arr[i].payStatus = '支付失败'
        } else if (arr[i].payStatus == 4) {
          arr[i].payStatus = '超时'
        } else if (arr[i].payStatus == 5) {
          arr[i].payStatus = '申请退款'
        } else if (arr[i].payStatus == 6) {
          arr[i].payStatus = '退款中'
        } else if (arr[i].payStatus == 7) {
          arr[i].payStatus = '退款成功'
        } else if (arr[i].payStatus == 8) {
          arr[i].payStatus = '退款失败'
        } else if (arr[i].payStatus == 9) {
          arr[i].payStatus = '支付已关闭'
        } else if (arr[i].payStatus == 10) {
          arr[i].payStatus = '退款已取消'
        }
        arr[i].payAmount = parseFloat(arr[i].payAmount).toFixed(2)
        //    arr[i].refundFee =  parseFloat(arr[i].refundFee).toFixed(2)
        arr[i].refundFee =
          arr[i].refundFee !== null && arr[i].refundFee != ''
            ? '￥' + parseFloat(arr[i].refundFee).toFixed(2) + '元'
            : ''
        arr[i].refundScale =
          arr[i].refundScale !== null &&
            arr[i].refundScale != 'Infinity' &&
            arr[i].refundScale != ''
            ? arr[i].refundScale + '%'
            : ''
      }
      this.list = arr

      this.$nextTick(() => {
        this.setSort()
      })
    },
    closeForm () {
      this.visible = false
    },
    //行拖拽
    setSort () {
      const el = this.$refs.dragTable.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody'
      )[0]
      this.sortable = new Sortable(el, {
        ghostClass: 'blue-background-class', // Class name for the drop placeholder,// 抓取的元素的类名，简单来说就是抓取元素的时候给他加一个类名blue-background-class
        setData: function (dataTransfer) {
          console.log('dataTransfer', dataTransfer)
          dataTransfer.setData('Text', '')
        },

        onEnd: (evt) => {
          console.log(evt)
          // console 一下 evt ，你就明白下面为什么这样写
          const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, targetRow)
        }

      })
    },
    //列拖拽
    columnDrop () {
      //   const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
      //   console.log(wrapperTr)
      //   this.sortable = Sortable.create(wrapperTr, {
      //     animation: 180,
      //     delay: 0,
      //     onEnd: evt => {
      //       const oldItem = this.dropCol[evt.oldIndex]
      //       this.dropCol.splice(evt.oldIndex, 1)
      //       this.dropCol.splice(evt.newIndex, 0, oldItem)
      //     }
      //   })
    }
  }
}
</script>
